import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { File } from "@ionic-native/file";
import { CONFIG } from "../../config/config";
import { LoadingProvider } from "../loading/loading";
import { stringify } from "@angular/core/src/util";
declare var cordova: any;

/*
  Generated class for the ScannerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ScannerProvider {
  constructor(public http: HttpClient, public loading: LoadingProvider) {}

  useGeniusScan() {

    const file = new File();

    const configuration = {
      source: "camera",
      jpegQuality: 20
    };

    const imageData: any = {};

    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      response => {
        console.log("initialized", response);
      },
      error => {
        console.log("initialized", error);
      }
    );
    cordova.plugins.GeniusScan.scanWithConfiguration(
      configuration,
      async result => {
        const [processed] = result.scans;
        const { enhancedUrl } = processed;
        const filename = enhancedUrl.substring(
          enhancedUrl.lastIndexOf("/") + 1
        );
        const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
        this.loading.presentLoading("Uploading...");
        const processedPath = `${path}${filename}`;
        const data = await file.readAsDataURL(path, filename);
        this.loading.loader.dismiss().catch(() => {});

      },
      error => {
        console.log(error);
      }
    );
    
  }

 async processScannedData(filepath) {
    const file = new File();
    const filename = filepath.substring(
      filepath.lastIndexOf("/") + 1
    );
    const path = filepath.substring(0, filepath.lastIndexOf("/") + 1);
    const processedPath = `${path}${filename}`;
    const data = await file.readAsDataURL(path, filename);
    return {data, path: processedPath}

  }

  initGeniusScan() {
    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      (response) => {
        console.log("initialized", response)
      },
      (error) => {
        console.log("initialized",error)
      }
    )
  }

  scanConfig() {
    return {
      source: 'camera',
      jpegQuality: 20
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/scanner/scanner.ts